import styled, { css } from 'styled-components';
import {
  StyledButton,
  StyledButtonContainer,
  InfoDark,
  StyledReactTooltip,
} from '../../../../../../globalStyled';
import { ReactComponent as StyledLeftArrowIcon } from '../../../../../../assets/img/go-arrow-left.svg';
import { fontUi, pill } from '../../../../../../theme/typography';

export const StyledInsight = styled.span`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  line-height: 1;

    svg {
    display: block;
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    margin: 0;
  }
`;

export const StyledLeftArrow = styled(StyledLeftArrowIcon)``;

export const StyledPatronLabel = styled.span`
  cursor: pointer;
`;

export const StyledDarkReactTooltip = styled(StyledReactTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.card};
  width: 190px;
  font-weight: 500;
  &.__react_component_tooltip.show {
    color: ${({ theme }) => theme.text};
    font-size: 13px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;

export const StyledTeamSquadContainer = styled.section``;
export const StyledChartContainer = styled.div`
  padding: 15px 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  }
`;
export const StyledCard = styled.div`
  padding: 0px;
  background: transparent;
  > p {
    margin: 14px 0;
    font-family: 'Archivo', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14.222px;
    line-height: 16px;
    letter-spacing: 0.005em;
    color: ${({ theme }) => theme.text};
  }
`;

export const StyledCardDetailItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-direction: column;
  width: auto;
  flex-grow: 1;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  padding: 16px 10px;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${({ half }) => {
    if (half)
      return css`
        width: 50%;
      `;
  }}
  ${({ oneThird }) => {
    if (oneThird)
      return css`
        flex: 1 1 0;
        width: auto;
        min-width: 0;
      `;
  }}
  ${({ topBorder }) => {
    if (topBorder)
      return css`
        border-top: 1px solid ${({ theme }) => theme.borderSubtle};
      `;
  }}
  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.borderSubtle};
  }
`;

export const StyledStayCluster = styled.div`
  display: flex;
  flex-direction: row;
  flex: 2 1 0;
  width: auto;
  min-width: 0;
  border-right: 1px solid ${({ theme }) => theme.borderSubtle};

  & > * {
    flex: 1 1 0;
    width: auto;
    min-width: 0;
  }
`;

export const StyledValue = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${({ color }) => color};
`;

export const StyledContractValue = styled(StyledValue)`
  font-size: 15px;
`;

export const StyledLabel = styled.span`
  font-family: Archivo;
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.textFaint};
  text-align: center;
  letter-spacing: 0.77px;
  padding-top: 5px;
`;
export const StyledPlayerData = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledPlayerControlButton = styled(StyledButton)`
  min-width: 84px;
  padding: 8px 6px;
  font-size: 12px;
  margin: 0 5px;
  width: 100%;
  cursor: ${({ nonClickable }) => (nonClickable ? 'default' : 'pointer')};
  box-shadow: none;
  ${({ theme, secondary }) =>
    theme.isDark &&
    !secondary &&
    css`
      && {
        background: transparent;
        color: ${theme.text};
        border: 1px solid ${theme.border};
      }
    `}
  /* @media only screen and (max-width: 426px) {
    width: 49%;
  } */
`;

export const StyledButtonsContainer = styled(StyledButtonContainer)`
  justify-content: space-evenly;
  padding: 12px 15px 16px;
  margin: 0;
  background: transparent;
  @media only screen and (max-width: 426px) {
    bottom: 0;
  }
`;

export const StyledControlContainer = styled(StyledButtonContainer)`
  justify-content: space-between;
  padding: 0 15px;
  margin: 10px 0;
  @media only screen and (max-width: 426px) {
    bottom: 0;
  }
`;

export const StyledTeamName = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.textMuted};
  font-weight: 500;
  font-family: 'Archivo';
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: ${({ isPremium }) => (isPremium ? '0' : '20px')};
`;

export const StyledInjuredLabel = styled.div`
  height: 35px;
  padding: 11px 14px 10px 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  ${({ type }) => {
    if (type === 'academy') {
      return css`
        background-color: #00996b;
      `;
    }
    if (type === 'injured' || type === 'suspended') {
      return css`
        background-color: #de3e32;
      `;
    }
    if (type === 'loanedOut') {
      return css`
        background-color: #7f7f7f;
      `;
    }
    if (type === 'loanedIn') {
      return css`
        background-color: #fdca40;
        span {
          color: #000;
        }
      `;
    }
  }}
`;
export const StyledLeftLabel = styled.span`
  color: #fff;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 500;
  padding-left: ${({ type }) =>
    type === 'loanedOut' || type === 'loanedIn' ? '0' : '15px'};
`;
export const StyldRightLabel = styled.span`
  font-family: Archivo;
  font-size: 12px;
  color: #fff;
`;

export const StyledPlus = styled.span`
  font-family: 'Archivo', sans-serif;
  font-weight: bold;
  font-size: 26px;
  position: absolute;
  left: 5px;
  top: 2px;
`;

export const StyledHeader = styled.div`
  padding-top: ${({ isMobileView }) => (isMobileView ? '70px' : '20px')};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.text};
  padding-bottom: 20px;
  > h3 {
    text-align: center;
    margin-bottom: 0px;
    font-family: Archivo;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 0.2px;
    line-height: 34px;
    color: ${({ theme }) => theme.text};
  }
`;
export const StyledScoutingHeader = styled.div`
  padding-top: 20px;
  font-size: 17px;
  font-weight: 600;
  text-align: center;
`;

export const StyledMobileInfoHeader = styled.h4`
  position: absolute;
  top: 0;
  z-index: 2;
  height: 45px;
  align-items: center;
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => theme.page};
  color: ${({ theme }) => theme.text};
  font-size: 15px;
  font-weight: bold;
  padding-left: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  svg {
    margin-right: 10px;
  }
`;

export const StyledSwitchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
`;

export const StyledSwitchBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
export const StyledSwitchContainer = styled.div`
  padding: 5px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSwitchLabel = styled.span`
  font-size: 12px;
  width: auto;
  height: 32px;
  color: ${({ theme }) => theme.text};
  font-family: 'Archivo', sans-serif;
  font-weight: 500;
  position: relative;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  line-height: 1;
  text-box: trim-both cap alphabetic;
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
`;

export const StyledInfoDark = styled(InfoDark)`
  margin-left: 5px;
`;

export const StyledSidebarButton = styled(StyledButton)`
  min-width: 120px;
  @media only screen and (max-width: 768px) {
    min-width: 160px;
  }
  @media only screen and (max-width: 769px) and (max-width: 1199px) {
    min-width: 120px;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  margin: 0px auto;
  &.clicked {
    background: ${({ theme }) => theme.accent};
    color: ${({ theme }) => theme.accentContrast || '#fff'};
  }
  ${({ clicked }) => {
    if (clicked)
      return css`
        pointer-events: none;
      `;
  }}
`;

export const StyledSliderWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.border};
  padding-top: ${({ searchPage }) => (searchPage ? '0' : '30px')};
`;

export const StyledParagraph = styled.p`
  margin: 5px 0;
  padding: 0 15px;
  text-align: center;
  font-family: Archivo;
  font-size: 13px;
  color: ${({ theme }) => theme.textMuted};
`;

export const StyledNicknameButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const StyledNicknameButton = styled(StyledButton)`
  height: 16px;
  color: ${({ theme }) => theme.page};
  background-color: ${({ theme }) => theme.text};
  border-radius: 6px;
  font-size: 10px;
  padding: 7px;
  min-width: 85px;
  margin: 10px 0 12px 0;
  ${({ isPremium }) => {
    if (!isPremium) {
      return css`
        opacity: 0.4;
      `;
    }
  }}

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export const StyledNicknameLabel = styled.span`
  font-size: 14px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.text};
`;

export const StyledHeaderName = styled.h3`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding-bottom: ${({ searchPage }) => (searchPage ? '20px' : '0px')};
  color: ${({ theme }) => theme.text};
`;

export const StyledToggleTeamView = styled.div`
  margin: 0 15px 20px;
  display: flex;
  position: relative;
  flex-direction: row;
  gap: 4px;
  padding: 3px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.hover};

  button {
    ${pill};
    ${fontUi};
    font-size: 12px;
    font-weight: 600;
    flex: 1;
    line-height: 1;
    text-box: unset;
    text-box-trim: none;
    color: ${({ theme }) => theme.textFaint};
    border: 0;
    outline: 0;
    padding: 8px 10px;
    cursor: pointer;
    background: transparent;
    gap: 4px;

    &.active {
      color: ${({ theme }) => theme.text};
      background: ${({ theme }) => theme.card};
    }
    svg {
      display: block;
      width: 12px;
      height: 12px;
      margin: 0;
      flex-shrink: 0;
    }
  }
`;

export const StyledTimePerformanceContainer = styled.div`
  font-size: 15px;
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
`;

export const StyledPerformanceIcon = styled.span`
width: 12px;
height: 12px;
margin: 0 2px;
border-radius: 50%;
background-color: ${({ color }) => color}`;
